import { render, staticRenderFns } from "./UserAutocomplete.vue?vue&type=template&id=2803834a"
import script from "./UserAutocomplete.vue?vue&type=script&lang=js"
export * from "./UserAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./UserAutocomplete.vue?vue&type=style&index=0&id=2803834a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports